var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "o-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "o-grid",
        class: _vm.cards.length === 0 ? "o-grid--center" : "",
      },
      [
        _vm.cards.length !== 0 || _vm.showPlaceholders
          ? _c("div", { staticClass: "o-grid__item u-width-full" }, [
              _c("div", { staticClass: "cards__wrapper" }, [
                _c(
                  "div",
                  { staticClass: "cards", attrs: { id: "cards" } },
                  [
                    _vm.showPlaceholders
                      ? _c("content-placeholders")
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.cards, function (card) {
                      return _c("post-card-api", {
                        key: card.id,
                        attrs: { card: card },
                      })
                    }),
                  ],
                  2
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showEmptyMessage
          ? _c(
              "div",
              {
                directives: [{ name: "else", rawName: "v-else" }],
                staticClass: "o-grid__item u-width-8/12 u-width-full@l",
              },
              [
                _vm.$root.user.username === _vm.$root.profile.username
                  ? _c("div", { staticClass: "c-empty-state" }, [
                      _c("h4", [
                        _vm._v(
                          "Ready to Like your first piece of " +
                            _vm._s(_vm.$root.community.title) +
                            " content?"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.mineNoContentMessage))]),
                    ])
                  : _c("div", { staticClass: "c-empty-state" }, [
                      _c("h4", [_vm._v(_vm._s(_vm.theirNoContentTitle))]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("As soon as they do it will be listed here."),
                      ]),
                    ]),
              ]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }